import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deal: null,
  totalStats: null,
  isLoading: false,
  isError: false,
  error: "",

  isSaving: false,
  isSaveSuccess: false,
};

const linkedinPromotionSlice = createSlice({
  name: "linkedinPromotion",
  initialState: initialState,
  reducers: {
    getLinkedinDeal: (state) => {
      state.isLoading = true;
      state.deal = null;
    },
    getLinkedinDealSuccess: (state, action) => {
      state.deal = action.payload;
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    },
    getLinkedinDealFailed: (state, action) => {
      state.deal = null;
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    },

    saveLinkedinDeal: (state) => {
      state.isSaving = true;
      state.isSaveSuccess = false;
    },
    saveLinkedinDealSuccess: (state, action) => {
      state.deal = action.payload;
      state.isSaving = false;
      state.isSaveSuccess = true;
    },
    saveLinkedinDealFailed: (state) => {
      state.isSaving = false;
      state.isSaveSuccess = false;
    },
    saveLinkedinDealReset: (state) => {
      state.isSaveSuccess = false;
    },

    getTotalLinkedinStats: (state) => {
      state.isLoading = true;
    },
    getTotalLinkedinStatsSuccess: (state, action) => {
      state.totalStats = action.payload;
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    },
    getTotalLinkedinStatsFailed: (state, action) => {
      state.totalStats = null;
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    },
  },
});

export const {
  getLinkedinDeal,
  getLinkedinDealSuccess,
  getLinkedinDealFailed,
  saveLinkedinDeal,
  saveLinkedinDealSuccess,
  saveLinkedinDealFailed,
  saveLinkedinDealReset,
  getTotalLinkedinStats,
  getTotalLinkedinStatsSuccess,
  getTotalLinkedinStatsFailed,
} = linkedinPromotionSlice.actions;

export default linkedinPromotionSlice.reducer;
